import { initResponse } from '../types/sdk';

const buildInitResponse = (loadStatus: boolean, errorMessage = ''): initResponse => {
  return {
    loaded: loadStatus,
    errorMessage,
  };
};

export default buildInitResponse;
